import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import { Global, css } from "@emotion/react";
import { sendSlackError } from "@src/api/error";
import { subscribeStibee } from "@src/api/sign";
import WebpImage from "@src/component/base/WebpImage";
import { EmptySpace } from "@src/component/SignComponent";
import useUser from "@src/hook/useUser";
import { FaqData, faqListClient } from "@src/model/applicationModel";
import { Empty, GroupA, ModalA, PaperA, useModal } from "@src/ruix";
import {
	defaultMessageAtom,
	globalSnackbarState,
	isApplyOpenAtom,
	isChatOpenAtom,
	userInfoAtom,
} from "@src/state";
import { validateEmail } from "@src/utils/sign";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import TagManager from "react-gtm-module";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { Autoplay, Navigation, Pagination, Scrollbar } from "swiper/modules";
import { Swiper as SwiperComponent, SwiperSlide } from "swiper/react";
import {
	AnswerListUl,
	BigInsightCard,
	BlogCtaButton,
	BpCard,
	BpList,
	CListPagination,
	ContentsContainer,
	CtaImageBox,
	CustomAccordion,
	FAQAnswerDiv,
	FAQAnswerDiv2,
	FAQAnswerList,
	FAQAnswerTitle,
	FAQButton,
	HowToVerifyStepTitle,
	HowToVerrifyBigTitle,
	HowtoSectionSmallTitle,
	InsightCard,
	InsightList,
	MainContentsContainer,
	MainCtaButton,
	MainCtaContentsContainer,
	MainCtaContentsInner,
	RollingTextSpan,
	PentagonSubTitle,
	PentagonTitle,
	PentagonTitle2,
	ProcessCard,
	ProcessCardList,
	ReviewCard,
	ReviewContainer,
	ReviewData,
	SectionRight,
	SectionSmallSubTitle,
	SectionSmallSubTitle2,
	SectionSmallTitle,
	SectionTitle,
	SectionTitleLeft,
	SubscribeButton,
	SubscribeInput,
	SwiperSectionContents,
	WhyCard,
	WhyCardList,
	profileDataArray,
} from "../../base/BaseContents";
import { CustomA } from "../mobile/MainContentsMobile";
import styled from "@emotion/styled";

export const MainContents = () => {
	const { user } = useUser();
	const router = useRouter();

	const setIsApplyOpen = useSetRecoilState(isApplyOpenAtom);
	const setIsChatOpen = useSetRecoilState(isChatOpenAtom);
	const userInfo = useRecoilValue(userInfoAtom);

	const setDefaultMessage = useSetRecoilState(defaultMessageAtom);
	const setSnackbareState = useSetRecoilState(globalSnackbarState);

	useEffect(() => {
		const scrollFunction = () => {
			if (scrollY > (document.querySelector("#client-apply-mid") as any)?.offsetHeight) {
				document.querySelector(".floating")?.classList.remove("hidden");
			} else {
				document.querySelector(".floating")?.classList.add("hidden");
			}
		};
		window.addEventListener("scroll", scrollFunction);
		return () => {
			window?.removeEventListener("scroll", scrollFunction);
		};
	}, []);

	const 플로팅버튼 = () => (
		<div className="floating column-center-center">
			<div
				onClick={() => {
					if (user.isLogin && user.userType === 2) {
						setSnackbareState(
							"고객사 전용 서비스입니다.\n문의사항은 우측 하단 채널톡을 이용해주시기 바랍니다.",
						);
						return;
					}
					const tagManagerArgs = {
						dataLayer: {
							event: `client-apply-start`,
						},
					};
					if (!window.localStorage.getItem("accessToken")) {
						TagManager.dataLayer(tagManagerArgs);
					}
					setDefaultMessage("");
					if (user.isLogin) {
						setIsChatOpen(true);
					} else {
						setIsApplyOpen(true);
					}
				}}
				className="floating-btn-apply apply-button"
			>
				<div>지금 바로 상담 받기</div>
			</div>
		</div>
	);
	return (
		<>
			<Global
				styles={css`
					.how-to-verify {
						border-radius: 20px;
						overflow: hidden;
						transition: transform 0.2s ease;

						&:hover {
							transform: translateY(-4px);
						}
					}
				`}
			/>
			<MainContentsContainer className="column-center-start">
				<MainCtaContents />
				<CIList />
				<WhenWeNeed />
				<HowToVerify />
				<ExpertList />
				<GetProfileNewsLetter />
				<Purpose />
				<Process />
				<BestPractice />
				<ReviewList />
				<BlogSection />
				<FAQSection list={faqListClient[0]} />
				{플로팅버튼()}
			</MainContentsContainer>
		</>
	);
};

const rollingNumbers = ["5", "10", "20"];

const MainCtaContents = () => {
	const { user } = useUser();
	const router = useRouter();

	const setIsApplyOpen = useSetRecoilState(isApplyOpenAtom);
	const setIsChatOpen = useSetRecoilState(isChatOpenAtom);
	const userInfo = useRecoilValue(userInfoAtom);
	const setDefaultMessage = useSetRecoilState(defaultMessageAtom);
	const setSnackbareState = useSetRecoilState(globalSnackbarState);

	const [numIndex, setNumIndex] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setNumIndex((prev) => (prev + 1) % rollingNumbers.length);
		}, 2500);
		return () => clearInterval(interval);
	}, []);

	return (
		<MainCtaContentsContainer className="column-center-center">
			<ContentsContainer className="column-center-center">
				<MainCtaContentsInner className="column-center-start">
					<h1
						className="cta-title-box"
						style={{
							margin: "0 auto",
						}}
					>
						<div className="row-center-center">
							<span>
								상위 <span className="blue">10%</span> 마케터를
							</span>
						</div>
						<div>
							<span>{"주"}</span>
							<RollingTextSpan key={numIndex} className="blue">
								{rollingNumbers[numIndex]}
							</RollingTextSpan>
							<span>{"시간 고용하세요"}</span>
						</div>
					</h1>
					<EmptySpace space={20} />
					<MainCtaButton
						variant="contained"
						id="client-apply-mid"
						className="apply-button"
						onClick={() => {
							if (user.isLogin && user.userType === 2) {
								setSnackbareState(
									"고객사 전용 서비스입니다.\n문의사항은 우측 하단 채널톡을 이용해주시기 바랍니다.",
								);
								return;
							}
							const tagManagerArgs = {
								dataLayer: {
									event: `client-apply-start`,
								},
							};
							if (!window.localStorage.getItem("accessToken")) {
								TagManager.dataLayer(tagManagerArgs);
							}
							setDefaultMessage("");
							if (user.isLogin) {
								setIsChatOpen(true);
							} else {
								setIsApplyOpen(true);
							}
						}}
					>
						지금 바로 상담 받기
					</MainCtaButton>
					<div
						onClick={() => {
							setDefaultMessage(
								`안녕하세요! 원포인트 AI 마케팅 상담봇입니다 🙂\n\n회사나 브랜드, 혹은 현재 상황이나 고민하고 계신 부분에 대해 편하게 말씀해주시면 차근차근 도와드릴게요!`,
							);
							if (user.isLogin && user.userType === 2) {
								setSnackbareState(
									"고객사 전용 서비스입니다.\n문의사항은 우측 하단 채널톡을 이용해주시기 바랍니다.",
								);
								return;
							}
							if (user.isLogin) {
								setIsChatOpen(true);
							} else {
								setIsApplyOpen(true);
							}
						}}
						className="ai-consult-button"
						style={{
							color: "#666666",
							textDecoration: "none",
							cursor: "pointer",
							fontSize: "14px",
							marginTop: "12px",
							transition: "all 0.2s ease",
							borderBottom: "1px solid transparent",
							paddingBottom: "2px",
							letterSpacing: "-0.3px",
						}}
						onMouseEnter={(e) => {
							e.currentTarget.style.borderBottom = "1px solid #666666";
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.borderBottom = "1px solid transparent";
						}}
					>
						5분 안에 마케팅 진단 먼저 받아보기
					</div>
				</MainCtaContentsInner>
			</ContentsContainer>
		</MainCtaContentsContainer>
	);
};
const WhenWeNeed = () => {
	const a = 1;

	return (
		<ContentsContainer className="column-center-start">
			<GroupA order="column-start-center" gap={20}>
				<SectionTitle>{`검증된 탑티어 프리랜서 마케터,\n언제 필요할까요?`}</SectionTitle>
			</GroupA>
			<EmptySpace space={40} />
			<PaperA variant="transparent" order="row-start-between" gap={8} px={0} py={0}>
				<WhyCard
					imgSrc={WhyCardList[0].imgSrc}
					title={WhyCardList[0].title}
					subTitle={WhyCardList[0].subTitle}
				/>
				<WhyCard
					imgSrc={WhyCardList[1].imgSrc}
					title={WhyCardList[1].title}
					subTitle={WhyCardList[1].subTitle}
				/>
			</PaperA>
			<EmptySpace space={8} />
			<PaperA variant="transparent" order="row-start-between" gap={8} px={0} py={0}>
				<WhyCard
					imgSrc={WhyCardList[2].imgSrc}
					title={WhyCardList[2].title}
					subTitle={WhyCardList[2].subTitle}
				/>
				<WhyCard
					imgSrc={WhyCardList[3].imgSrc}
					title={WhyCardList[3].title}
					subTitle={WhyCardList[3].subTitle}
				/>
			</PaperA>
		</ContentsContainer>
	);
};
const HowToVerify = () => {
	const { openModal, isOpen, closeModal } = useModal();
	const router = useRouter();

	useEffect(() => {
		if (router.query["expert-evaluation-example"] === "true") {
			openModal();
		}
	}, [router.query]);

	return (
		<ContentsContainer>
			<ContentsContainer
				className="column-center-start how-to-verify"
				style={{
					background: "var(--bg-white)",
					padding: 0,
				}}
			>
				<Empty space={95} />
				<SectionTitle>3단계 검증 시스템으로</SectionTitle>
				<HowToVerrifyBigTitle>
					<span className="blue">상위 10% 마케터</span>
					<span>를 선발합니다</span>
				</HowToVerrifyBigTitle>
				<Empty space={80} />
				<div
					className="row-start-start"
					style={{
						width: "100%",
						height: "560px",
						paddingLeft: "116px",
					}}
				>
					<div
						style={{
							paddingRight: "53px",
						}}
					>
						<Empty space={10} />
						<GroupA order="column-start-start">
							<HowToVerifyStepTitle
								style={{
									width: 40,
								}}
							>
								1단계
							</HowToVerifyStepTitle>
							<HowtoSectionSmallTitle>서류 평가</HowtoSectionSmallTitle>
							<FAQAnswerDiv2>{`이력, 프로젝트 경험, 포트폴리오를 기반으로\n경력과 성과를 확인합니다`}</FAQAnswerDiv2>
						</GroupA>
						<Empty space={90} />
						<GroupA order="column-start-start">
							<HowToVerifyStepTitle
								style={{
									width: 40,
								}}
							>
								2단계
							</HowToVerifyStepTitle>
							<HowtoSectionSmallTitle>역량 평가</HowtoSectionSmallTitle>
							<FAQAnswerDiv2>{`논술형 평가를 통해\n직무별 문제 해결 역량과 스킬을 파악합니다`}</FAQAnswerDiv2>
						</GroupA>
						<Empty space={100} />
						<GroupA order="column-start-start">
							<HowToVerifyStepTitle
								style={{
									width: 40,
								}}
							>
								3단계
							</HowToVerifyStepTitle>
							<HowtoSectionSmallTitle>심층 면접</HowtoSectionSmallTitle>
							<FAQAnswerDiv2>{`커뮤니케이션 역량 및\n적극성 등 소프트 스킬을 검증합니다`}</FAQAnswerDiv2>
						</GroupA>
					</div>
					<WebpImage
						width={184}
						src="/onepoint/images/renewal/how-section/diagram.png"
						alt=""
					/>
					<div
						className="column-center-end"
						style={{
							justifyContent: "flex-end",
							alignItems: "flex-end",
						}}
					>
						<Empty space={35} />
						<div
							style={{
								paddingRight: "187px",
							}}
						>
							<GroupA order="column-start-start" gap={0}>
								<PentagonSubTitle>합격률</PentagonSubTitle>
								<GroupA order="row-center-start">
									<PentagonTitle>70</PentagonTitle>
									<PentagonTitle2>%</PentagonTitle2>
								</GroupA>
							</GroupA>
						</div>
						<Empty space={145} />
						<div
							style={{
								paddingRight: "203px",
							}}
						>
							<GroupA order="column-start-start" gap={0}>
								<PentagonSubTitle>합격률</PentagonSubTitle>
								<GroupA order="row-center-start">
									<PentagonTitle>30</PentagonTitle>
									<PentagonTitle2>%</PentagonTitle2>
								</GroupA>
							</GroupA>
						</div>
						<Empty space={132} />
						<div
							style={{
								paddingRight: "229px",
							}}
						>
							<GroupA order="column-start-start" gap={0}>
								<PentagonSubTitle>합격률</PentagonSubTitle>
								<GroupA order="row-center-start">
									<PentagonTitle>10</PentagonTitle>
									<PentagonTitle2>%</PentagonTitle2>
								</GroupA>
							</GroupA>
						</div>
					</div>
				</div>
				<Empty space={80} />
				<BlogCtaButton variant="contained" onClick={openModal}>
					실제 역량 평가 사례가 궁금하다면?
				</BlogCtaButton>
				<EmptySpace space={40} />
			</ContentsContainer>
			<ModalA
				zIndex={10001}
				maxWidth="800px"
				bgColor="white"
				isOpen={isOpen}
				onClose={closeModal}
			>
				<PaperA variant="transparent" order="column-center-center" gap={16} px={16} py={0}>
					<SectionSmallTitle>실제 역량 평가 문제 & 답변</SectionSmallTitle>
					<PaperA
						variant="transparent"
						order="column-center-center"
						gap={30}
						px={16}
						py={0}
					>
						<SectionSmallSubTitle>
							당신은 글로벌 가전 브랜드 Dyson의 디지털 마케팅팀에서 최근 출시한
							프리미엄 공기청정기 라인의 온라인 광고 캠페인을 담당하고 있습니다. 지난
							분기 동안 이 제품 라인의 자사 온라인 스토어 판매가 예상보다 저조했으며,
							특히 주요 타겟 그룹에서의 구매 전환율이 낮은 것으로 나타났습니다. 초기
							분석 결과, 주요 원인으로는 다음 두 가지가 지목되었습니다.
						</SectionSmallSubTitle>
						<SectionSmallSubTitle2>
							1. 경쟁 브랜드들의 공격적인 마케팅으로 인한 시장 점유율 감소 <br></br>2.
							소비자들의 높은 가격 민감도와 경기 불황으로 인한 구매 의사 결정 지연
						</SectionSmallSubTitle2>
						<SectionSmallSubTitle>
							온라인 광고 성과는 전반적으로 기대에 미치지 못하고 있으며, 특히 광고
							클릭에서 실제 구매로 이어지는 전환율이 낮은 상황입니다. 현재 상황을
							어떻게 분석하고 온라인 광고에서의 전환율 향상을 위해 어떤 전략과 액션을
							수행할지 서술하세요.
						</SectionSmallSubTitle>
					</PaperA>
					<EmptySpace space={20} />
					<WebpImage
						style={{
							maxWidth: "100%",
							padding: "0 32px",
						}}
						src="/onepoint/images/renewal/how-section/example.png"
						alt=""
					/>
				</PaperA>
			</ModalA>
		</ContentsContainer>
	);
};

const ExpertList = () => {
	const a = 1;
	return (
		<SwiperSectionContents className="column-center-start">
			<PaperA variant="transparent" order="row-end-between" gap={20} px={16} py={0} fullWidth>
				<SectionTitleLeft>{`원포인트 자체 검증 시스템을 거친\n탑티어 전문가를 만나보세요`}</SectionTitleLeft>
				<div className="swiper-pagination"></div>
			</PaperA>
			<EmptySpace space={80} />
			<section className="profile-box">
				<SwiperComponent
					navigation={{
						nextEl: ".swiper-button-next-unique",
						prevEl: ".swiper-button-prev-unique",
					}}
					modules={[Pagination, Navigation, Scrollbar, Autoplay]}
					slidesPerView={1}
					slidesPerGroup={1}
					centeredSlides={false}
					loop={true}
					spaceBetween={20}
					pagination={{
						el: ".swiper-pagination",
						// renderBullet: function (index, className) {
						// 	return `<span key=${index} class="${className}">${index + 1}</span>`;
						// },
					}}
					autoplay={{
						delay: 3000,
						disableOnInteraction: true,
						pauseOnMouseEnter: true,
					}}
					breakpoints={{
						1023: {
							slidesPerView: 3,
							slidesPerGroup: 3,
							spaceBetween: 32,
							centeredSlides: false,
							autoplay: {
								delay: 5000,
								disableOnInteraction: true,
								pauseOnMouseEnter: true,
							},
						},
						600: {
							slidesPerView: 2,
							slidesPerGroup: 2,
							spaceBetween: 32,
							centeredSlides: false,
							autoplay: {
								delay: 5000,
								disableOnInteraction: true,
								pauseOnMouseEnter: true,
							},
						},
					}}
				>
					{profileDataArray.map((v, i) => (
						<SwiperSlide key={`profileData-${i}`}>
							<div className="profile-item">
								<div className="top-box">
									<WebpImage
										className="profile-img"
										src={v.imageUrl}
										alt={`${v.name} 프로필이미지`}
									/>
									<div className="name">{v.name}</div>
									<div className="job">{v.job}</div>
									<GroupA order="row-center-start" gap={2}>
										<WebpImage
											src="/onepoint/images/renewal/expert-section/verify.png"
											alt=""
											style={{
												width: "16px",
												height: "16px",
											}}
										></WebpImage>
										<span
											style={{
												fontSize: "12px",
												color: "var(--primary)",
											}}
										>
											검증된 전문가
										</span>
									</GroupA>
									<EmptySpace space={8} />
								</div>
								<div className="bottom-box">
									<div className="introduction">{v.introduction}</div>
									<div className="skill-box">
										{[v.tagList, v.skillList].flat().map((skill, i) => (
											<div key={`profile-skill-${i}`} className="skill">
												{skill}
											</div>
										))}
									</div>
									<div
										className="go-profile"
										onClick={() => {
											window.open(v.profileUrl, "_blank");
										}}
									>
										<div>프로필 보기 </div>
									</div>
								</div>
							</div>
						</SwiperSlide>
					))}
				</SwiperComponent>
			</section>
		</SwiperSectionContents>
	);
};
const GetProfileNewsLetter = () => {
	const a = 1;

	const setSnackbareState = useSetRecoilState(globalSnackbarState);
	const [email, setEmail] = React.useState("");

	const [isLoad, setIsLoad] = React.useState(false);

	const handleOnClick = async () => {
		if (validateEmail(email)) {
			try {
				setIsLoad(true);
				await subscribeStibee({
					email: email,
					type: "프로필",
					ads: "O",
				});
			} catch (error) {
				await sendSlackError({
					message: "구독하기 실패" + email,
					title: "구독 프론트엔드 에러",
					channel: "error",
				});
			} finally {
				setIsLoad(false);
			}
			setSnackbareState("구독이 완료되었습니다.");
			setEmail("");
		} else {
			setSnackbareState("이메일 형식이 맞지 않습니다.");
		}
	};

	return (
		<ContentsContainer
			className="row-center-between"
			style={{
				background: "var(--bg-white)",
				borderRadius: "20px",
				padding: "60px 40px",
				boxShadow: "0px 4px 24px 0px rgba(0, 0, 0, 0.07)",
			}}
		>
			<SectionTitleLeft>{`탑티어 전문가의\n프로필을 받아보세요`}</SectionTitleLeft>
			<GroupA order="column-start-start" gap={4}>
				<GroupA order="row-center-center" gap={4}>
					<SubscribeInput
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						placeholder="work@email.com"
					></SubscribeInput>
					<SubscribeButton
						variant="contained"
						loading={isLoad}
						id={"subscribe_profile"}
						onClick={handleOnClick}
					>
						구독하기
					</SubscribeButton>
				</GroupA>
				<p
					style={{
						color: "var(--desc-gray)",
						fontSize: "14px",
						marginTop: "5px",
						textAlign: "right",
						letterSpacing: "-0.64px",
					}}
				>
					구독시{" "}
					<CustomA
						style={{
							color: "var(--desc-gray)",
							letterSpacing: "-0.64px",
						}}
						target="_blank"
						href="https://notion.1point.kr/privacy"
						rel="noreferrer"
					>
						개인정보 수집 및 이용
					</CustomA>
					에 동의하게 됩니다
				</p>
			</GroupA>
		</ContentsContainer>
	);
};

const list = [
	{
		title: "퍼포먼스 마케터",
		a: {
			title: "어떤 상황에 고용하나요?",
			list: [
				"목적에 맞는 디지털 광고 구성과 광고비 성과 최적화가 필요할 때",
				"광고비를 사용해 콘텐츠 마케팅 대비 빠른 유입/전환을 만들어야 할 때",
				"소비자 타겟 및 데이터를 광고를 통해 파악해야 할 때",
			],
			exList: [
				"퍼포먼스 마케팅 매체 전략 수립",
				"미디어 믹스 전략 기획",
				"소재 A/B 테스트",
				"소재 셋팅과 성과 최적화",
				"성과 분석 및 리포팅",
				"대행사 활용 시 대행사 핸들링",
				"메타/구글/네이버 키워드 등 필요 매체 운영",
			],
			button: {
				text: "성공 사례 보기",
				url: "https://1point.kr/blog/best-practices/mj-groupby/",
			},
		},
	},
	{
		title: "브랜드 마케터",
		a: {
			title: "어떤 상황에 고용하나요?",
			list: [
				"전반적인 브랜드 전략 수립이 필요할 때",
				"BI를 소비자에게 인식시키기 위한 장기 전략이 필요할 때",
				"소비자에게 사랑받는 브랜드 아이덴티티(BI) 구축이 필요할 때",
			],
			exList: [
				"브랜드 전략 수립 (컨셉/브랜드 네이밍 개발)",
				"브랜드 포지셔닝 전략 수립",
				"브랜드 컨셉 및 핵심가치 등 전략 수립",
				"브랜드 마케팅 캠페인 실행안 기획",
				"브랜드 광고 마케팅 전략 수립",
				"브랜드 마케팅 대행사 활용 시 대행사 핸들링",
			],
			button: {
				text: "성공 사례 보기",
				url: "https://1point.kr/blog/best-practices/philip-startupcode/",
			},
		},
	},
	{
		title: "콘텐츠 마케터",
		a: {
			title: "어떤 상황에 고용하나요?",
			list: [
				"타겟에게 적합하고 신선한 크리에이티브 기획이 필요할 때",
				"일관적인 브랜드 이미지 구축과 커뮤니케이션을 위한 콘텐츠 기획이 필요할 때",
				"SNS 초기 셋팅 시 콘텐츠의 톤앤매너와 방향성 수립이 필요할 때",
			],
			exList: [
				"콘텐츠 마케팅 방향성/매체 전략 수립",
				"콘텐츠 전략과 톤앤매너 전략 수립",
				"이미지/영상 콘텐츠 기획",
				"콘텐츠 발행 및 성과 분석",
				"상세 페이지 기획/개선/가이드/카피라이팅",
				"광고 소재 기획/카피라이팅",
			],
			button: {
				text: "성공 사례 보기",
				url: "https://1point.kr/blog/best-practices/paradot/",
			},
		},
	},
	{
		title: "블로그/뉴스레터 마케터",
		a: {
			title: "어떤 상황에 고용하나요?",
			list: [
				"장기적으로 블로그 콘텐츠를 발행해 소비자의 신뢰도를 올려야 할 때",
				"소비자가 많은 정보를 찾아보는 고관여 제품, B2B 제품 판매 시 특히 적합",
				"유저와의 커뮤니케이션으로 광고비 없이 오가닉 유입을 이끌어야 할 때",
			],
			exList: [
				"블로그 콘텐츠 전략과 톤앤매너 전략 수립",
				"블로그/뉴스레터 콘텐츠 기획 & 작성",
				"블로그/뉴스레터 발행 및 성과 분석",
			],
			button: {
				text: "성공 사례 보기",
				url: "https://1point.kr/blog/best-practices/nry-boundx/",
			},
		},
	},
	{
		title: "이커머스 마케터",
		a: {
			title: "어떤 상황에 고용하나요?",
			list: [
				"자사몰 제품 판매를 위한 마케팅 전략이 필요할 때",
				"광고 클릭율은 높은데 전환이 떨어질 때",
				"자사몰 및 상세 페이지 전반에 대한 개선과 가이드가 필요할 때",
			],
			exList: [
				"자사몰 전환 최적화를 위한 액션 제안과 실행",
				"제품 상세 페이지 개선 기획",
				"전환율 최적화 전략 수립",
				"이커머스 광고 캠페인 기획 및 실행",
				"성과 분석 및 리포팅",
				"대행사 활용 시 대행사 핸들링",
			],
			button: {
				text: "성공 사례 보기",
				url: "https://1point.kr/blog/best-practices/purposed-dreve/",
			},
		},
	},
	{
		title: "CRM 마케터",
		a: {
			title: "어떤 상황에 고용하나요?",
			list: [
				"초기 CRM 전략 및 툴 셋팅이 필요할 때",
				"고객 세그먼트를 체계적으로 관리하고 싶을 때",
				"고객 세그먼트에 맞춰 재구매와 추가 구매를 유도해야 할 때",
			],
			exList: [
				"CRM 툴 셋팅과 캠페인 기획&운영",
				"고객 데이터 분석",
				"고객 세그먼트화",
				"데이터를 통한 고객 만족도 조사 및 개선",
				"채널톡/이메일 캠페인 기획 및 운영",
			],
			button: {
				text: "성공 사례 보기",
				url: "https://1point.kr/blog/",
			},
		},
	},
	{
		title: "SEO/SEM 마케터",
		a: {
			title: "어떤 상황에 고용하나요?",
			list: [
				"검색 엔진에서 회사와 제품 상위 노출이 필요할 때",
				"검색을 통한 오가닉 유입 전략을 세우고 싶을 때",
			],
			exList: [
				"SEO/SEM 현황 점검/전략 도출",
				"검색 엔진 최적화 전략 수립",
				"구글 애널리틱스 분석",
				"키워드 연구 및 분석",
			],
			button: {
				text: "성공 사례 보기",
				url: "https://1point.kr/blog/",
			},
		},
	},
	{
		title: "디자이너",
		a: {
			title: "어떤 상황에 고용하나요?",
			list: [
				"고객에게 신뢰를 주는 일관된 브랜드 아이덴티티(BI/CI) 구축이 필요할 때",
				"사용자 경험(UX/UI)을 개선하여 웹/앱 서비스의 이탈률을 낮추고 싶을 때",
				"마케팅 메시지를 효과적으로 전달하는 상세페이지, 광고 소재 등이 필요할 때",
			],
			exList: [
				"브랜드 아이덴티티(로고, 컬러, 서체) 시스템 구축",
				"웹/앱 서비스의 UX/UI 설계 및 디자인",
				"상세페이지, 이벤트 페이지 등 마케팅 콘텐츠 디자인",
				"SNS 채널(인스타그램, 페이스북) 콘텐츠 디자인",
				"브로슈어, 명함 등 인쇄물 디자인",
				"전체적인 디자인 톤앤매너 수립 및 가이드라인 제작",
			],
			button: {
				text: "성공 사례 보기",
				url: "https://1point.kr/blog",
			},
		},
	},
	{
		title: "영상 소재 제작 전문가",
		a: {
			title: "어떤 상황에 고용하나요?",
			list: [
				"제품/서비스를 매력적으로 보여줄 광고 영상이 필요할 때",
				"시선을 사로잡는 숏폼(릴스, 쇼츠) 콘텐츠를 만들고 싶을 때",
				"브랜드 스토리 등 전문적인 영상이 필요할 때",
				"콘텐츠는 있지만, 영상으로 만드는 데 어려움을 겪을 때",
			],
			exList: [
				"영상 소재 기획, 제작 및 편집",
				"플랫폼별 영상 최적화",
			],
			button: {
				text: "성공 사례 보기",
				url: "https://1point.kr/blog",
			},
		},
	},
];

const Purpose = () => {
	//
	const a = 1;
	return (
		<ContentsContainer className="column-start-start">
			<GroupA order="column-center-center" gap={20} fullWidth>
				<SectionTitle>{`목적에 맞는 전문가를 매칭 받으세요`}</SectionTitle>
			</GroupA>
			<EmptySpace space={40} />
			<SectionRight>
				{list.map((faq, i) => (
					<CustomAccordion key={`accordion${i}`} defaultExpanded={i === 0}>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon htmlColor="black" />}
							sx={{
								color: "var(--card-bg)",
								paddingLeft: "24px",
							}}
						>
							<SectionSmallTitle style={{ fontSize: "22px" }}>{faq.title}</SectionSmallTitle>
						</AccordionSummary>
						<AccordionDetails
							sx={{
								color: "black",
								whiteSpace: "pre-wrap",
								background: "white",
								display: "flex",
								flexDirection: "column",
								alignItems: "start",
								gap: "20px",
								paddingBottom: "20px",
								paddingLeft: "24px",
							}}
						>
							<GroupA order="row-start-between" gap={12} fullWidth>
								<GroupA order="column-start-start" gap={8} fullWidth>
									<FAQAnswerTitle>{faq.a.title}</FAQAnswerTitle>
								</GroupA>
								<GroupA order="row-start-between" gap={8} fullWidth>
									<AnswerListUl>
										{faq.a.list.map((item, index) => (
											<FAQAnswerList key={`faq-answer-${index}`}>
												{item}
											</FAQAnswerList>
										))}
									</AnswerListUl>
									<ul
										style={{
											width: "360px",
										}}
									>
										{faq.a.exList.map((item, index) => (
											<FAQAnswerList key={`faq-answer-ex-${index}`}>
												{item}
											</FAQAnswerList>
										))}
									</ul>
								</GroupA>
							</GroupA>
							<FAQButton
								variant="contained"
								onClick={() => {
									window.open(faq.a.button.url);
								}}
							>
								{faq.a.button.text}
							</FAQButton>
						</AccordionDetails>
					</CustomAccordion>
				))}
			</SectionRight>
		</ContentsContainer>
	);
};
const Process = () => {
	const a = 1;

	return (
		<ContentsContainer className="column-center-start">
			<GroupA order="column-start-center" gap={20}>
				<SectionTitle>{`상담에서 계약까지 7일\n빠른 업무 투입이 가능합니다`}</SectionTitle>
			</GroupA>
			<EmptySpace space={40} />
			<GroupA order="row-start-between" gap={16}>
				{ProcessCardList.map((item, index) => (
					<ProcessCard
						key={"ProcessCard" + index}
						imgSrc={item.imgSrc}
						title={item.title}
						subTitle={item.subTitle}
					/>
				))}
			</GroupA>
		</ContentsContainer>
	);
};
const CIList = () => {
	// 로고 데이터 배열 - ci-images 폴더의 모든 파일들
	const allLogoData = [
		"/onepoint/images/renewal/ci-images/jandi.png",
		"/onepoint/images/renewal/ci-images/apartmentary.png",
		"/onepoint/images/renewal/ci-images/lgelec.png",
		"/onepoint/images/renewal/ci-images/lguplus.png",
		"/onepoint/images/renewal/ci-images/mckinsey.png",
		"/onepoint/images/renewal/ci-images/levit.png",
		"/onepoint/images/renewal/ci-images/youhan.png",
		"/onepoint/images/renewal/ci-images/dotus.png",
		"/onepoint/images/renewal/ci-images/frendliai.png",
		"/onepoint/images/renewal/ci-images/freedom.png",
		"/onepoint/images/renewal/ci-images/kearney.png",
		"/onepoint/images/renewal/ci-images/esther.png",
		"/onepoint/images/renewal/ci-images/fursys.png",
		"/onepoint/images/renewal/ci-images/celimax.png",
		"/onepoint/images/renewal/ci-images/salady.png",
		"/onepoint/images/renewal/ci-images/hanwha.png",
		"/onepoint/images/renewal/ci-images/r2w.png",
		"/onepoint/images/renewal/ci-images/heum.png",
		"/onepoint/images/renewal/ci-images/rsquare.png",
	];

	// 첫 번째 줄용 로고 (앞쪽 10개)
	const firstRowLogos = allLogoData.slice(0, 10);
	// 두 번째 줄용 로고 (뒤쪽 10개)
	const secondRowLogos = allLogoData.slice(10, 20);
	return (
		<div
			className="ci-list"
			style={{ width: "100vw", marginLeft: "calc(-50vw + 50%)", background: "white" }}
		>
			<div style={{ maxWidth: "1024px", margin: "0 auto", padding: "0 20px" }}>
				<SectionTitle>성장하는 기업은 원포인트를 이용합니다</SectionTitle>
				<EmptySpace space={40} />
			</div>

			{/* 로고 슬라이더 섹션 - 전체 화면 너비 */}
			<div style={{ width: "100vw", overflow: "hidden", padding: "0 20px" }}>
				{/* 첫 번째 줄 - 왼쪽으로 흐름 */}
				<div style={{ marginBottom: "30px" }}>
					<SwiperComponent
						modules={[Autoplay]}
						slidesPerView="auto"
						spaceBetween={0}
						loop={true}
						freeMode={true}
						dir="rtl"
						autoplay={{
							delay: 0,
							disableOnInteraction: false,
						}}
						speed={4000}
						style={{
							width: "100%",
							transitionTimingFunction: "linear",
						}}
					>
						{[
							...firstRowLogos,
							...firstRowLogos,
							...firstRowLogos,
							...firstRowLogos,
							...firstRowLogos,
						].map((logo, index) => (
							<SwiperSlide
								key={`logo-1-${index}`}
								style={{
									width: "180px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<div
									style={{
										height: "70px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",

										transition: "all 0.3s linear",
									}}
								>
									<WebpImage
										src={logo}
										alt={`company-${index + 1}`}
										style={{
											objectFit: "contain",
											height: "70px",
										}}
									/>
								</div>
							</SwiperSlide>
						))}
					</SwiperComponent>
				</div>

				{/* 두 번째 줄 - 오른쪽으로 흐름 */}
				<div>
					<SwiperComponent
						modules={[Autoplay]}
						slidesPerView="auto"
						spaceBetween={0}
						loop={true}
						freeMode={true}
						autoplay={{
							delay: 0,
							disableOnInteraction: false,
						}}
						speed={4000}
						style={{
							width: "100%",
							transitionTimingFunction: "linear !important",
						}}
					>
						{[
							...secondRowLogos,
							...secondRowLogos,
							...secondRowLogos,
							...secondRowLogos,
							...secondRowLogos,
						].map((logo, index) => (
							<SwiperSlide
								key={`logo-2-${index}`}
								style={{
									width: "180px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<div
									style={{
										height: "70px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										transition: "all 0.3s linear",
									}}
								>
									<WebpImage
										src={logo}
										alt={`company-${index + 1}`}
										style={{
											objectFit: "contain",
											height: "70px",
										}}
									/>
								</div>
							</SwiperSlide>
						))}
					</SwiperComponent>
				</div>
			</div>
		</div>
	);
};

const ReviewList = () => (
	<ContentsContainer className="column-center-start">
		<ReviewContainer>
			<SwiperComponent
				modules={[Pagination, Scrollbar, Autoplay]}
				slidesPerView={3}
				slidesPerGroup={3}
				centeredSlides={false}
				loop={true}
				spaceBetween={20}
				pagination={{
					clickable: true,
					el: ".c-list-pagination2",
				}}
				autoplay={{
					delay: 5000,
					disableOnInteraction: true,
					pauseOnMouseEnter: true,
				}}
				breakpoints={{
					820: {
						slidesPerView: 3,
						slidesPerGroup: 3,
						spaceBetween: 20,
						centeredSlides: false,
						autoplay: {
							delay: 5000,
							disableOnInteraction: true,
							pauseOnMouseEnter: true,
						},
					},
				}}
			>
				{ReviewData.map((v, i) => (
					<SwiperSlide key={`review-${i}`}>
						<ReviewCard>
							<GroupA order="column-center-start" gap={12}>
								<GroupA order="column-center-start" gap={8}>
									<div className="title">{v.title}</div>
									<div className="desc">{v.description}</div>
								</GroupA>
								<GroupA order="column-start-start" gap={8} fullWidth>
									<WebpImage className="img" src={v.img} alt="" />
									<div className="name">
										{v.company} {v.name ? `| ${v.name} ${v.position}` : ""}
									</div>
								</GroupA>
							</GroupA>
						</ReviewCard>
					</SwiperSlide>
				))}
			</SwiperComponent>
		</ReviewContainer>
		<EmptySpace space={24} />
		<CListPagination className="c-list-pagination2 row-center-center"></CListPagination>
	</ContentsContainer>
);

const BestPractice = () => {
	//
	const a = 1;
	return (
		<ContentsContainer className="column-center-start">
			<SectionTitle>{"원포인트 고객사의\n실제 성공 사례입니다"}</SectionTitle>
			<Empty space={40} />
			<GroupA order="row-start-between" gap={8} bgColor="" style={{ rowGap: "16px", flexWrap: "wrap" }}>
				{BpList.map((v, i) => (
					<BpCard
						key={`bp-card-${i}`}
						onClick={() => {
							window.open(v.url);
						}}
					>
						<div
							style={{
								height: "100%",
								width: "100%",
							}}
							className="column-start-between"
						>
							<WebpImage className="img" src={v.imgSrc} alt="bp_ap.png" />
							<PaperA
								variant="transparent"
								px={20}
								py={20}
								order="column-start-start"
								gap={8}
							>
								<div className="title">{v.title}</div>
								<div className="card">{v.name}</div>
							</PaperA>
						</div>
					</BpCard>
				))}
			</GroupA>
			<EmptySpace space={40} />
			<BlogCtaButton
				variant="contained"
				onClick={() => {
					window.open("https://1point.kr/blog/best-practices/");
				}}
			>
				더 보러가기
			</BlogCtaButton>
		</ContentsContainer>
	);
};

const BlogSection = () => {
	//
	const a = 1;
	return (
		<ContentsContainer className="column-center-center">
			<SectionTitle>{`검증된 전문가의\n인사이트를 만나보세요`}</SectionTitle>
			<Empty space={40} />
			<GroupA order="row-center-start" gap={8}>
				{InsightList.slice(0, 1).map((v, i) => (
					<BigInsightCard
						key={`insight-card-${i}`}
						onClick={() => {
							window.open(v.url);
						}}
					>
						<WebpImage className="thumb" src={v.imgSrc} />
						<PaperA
							variant="transparent"
							px={24}
							py={24}
							order="column-start-start"
							gap={4}
						>
							<GroupA order="column-start-start" gap={8}>
								{/* <div className="tag">{v.type}</div> */}
								<div className="title">{v.title}</div>
							</GroupA>
							<GroupA order="column-start-start" gap={18}>
								<div className="name">by {v.name}</div>
								<div className="text">{v.text}</div>
							</GroupA>
						</PaperA>
					</BigInsightCard>
				))}
				<GroupA order="column-start-start">
					<div
						className="row-center-center"
						style={{
							flexGrow: 1,
							flexShrink: 1,
							flexBasis: "0%",
							gap: 8,
						}}
					>
						{InsightList.slice(1, 3).map((v, i) => (
							<InsightCard
								key={`insight-card-${i}`}
								onClick={() => {
									window.open(v.url);
								}}
							>
								<WebpImage className="thumb" src={v.imgSrc} />
								<PaperA
									variant="transparent"
									px={16}
									py={16}
									order="column-start-start"
									gap={4}
								>
									<GroupA order="column-start-start" gap={8}>
										{/* <div className="tag">{v.type}</div> */}
										<div className="title">{v.title}</div>
									</GroupA>
									<div className="name">by {v.name}</div>
								</PaperA>
							</InsightCard>
						))}
					</div>
					<div
						className="row-center-center"
						style={{
							flexGrow: 1,
							flexShrink: 1,
							flexBasis: "0%",
							gap: 8,
						}}
					>
						{InsightList.slice(3, 5).map((v, i) => (
							<InsightCard
								key={`insight-card-${i}`}
								onClick={() => {
									window.open(v.url);
								}}
							>
								<WebpImage className="thumb" src={v.imgSrc} />
								<PaperA
									variant="transparent"
									px={16}
									py={16}
									order="column-start-start"
									gap={4}
								>
									<GroupA order="column-start-start" gap={8}>
										{/* <div className="tag">{v.type}</div> */}
										<div className="title">{v.title}</div>
									</GroupA>
									<div className="name">by {v.name}</div>
								</PaperA>
							</InsightCard>
						))}
					</div>
				</GroupA>
			</GroupA>

			<EmptySpace space={40} />
			<BlogCtaButton
				variant="contained"
				onClick={() => {
					window.open("https://1point.kr/blog/insights/");
				}}
			>
				더 보러가기
			</BlogCtaButton>
		</ContentsContainer>
	);
};

const FAQContainer = styled.div`
	border-radius: 16px;
	overflow: hidden;
	box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.08);
	width: 100%;
	max-width: 800px;
	margin: 0 auto;

	& > * {
		margin: 0 !important;
		border-radius: 0 !important;
		box-shadow: none !important;
	}

	& > *:not(:last-child) {
		border-bottom: 1px solid rgba(0, 0, 0, 0.06);
	}
`;

export const FAQSection = (props: { list: FaqData[]; noTitle?: boolean }) => {
	const { list, noTitle } = props;
	return (
		<ContentsContainer className="column-center-center">
			{!noTitle && (
				<Typography
					sx={{
						color: "#111827",
						fontSize: { xs: "28px", sm: "32px", md: "36px" },
						fontWeight: 800,
						mb: 2,
						textAlign: "center",
						letterSpacing: "-0.03em",
						lineHeight: 1.2,
					}}
				>
					자주 묻는 질문
				</Typography>
			)}
			<EmptySpace space={30} />
			<FAQContainer>
				{list.map((faq, i) => (
					<CustomAccordion key={`accordion-faq-${i}`} defaultExpanded={i === 0}>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon htmlColor="black" />}
							sx={{
								color: "var(--card-bg)",
							}}
						>
							<FAQAnswerTitle>Q. {faq.title}</FAQAnswerTitle>
						</AccordionSummary>
						<AccordionDetails
							sx={{
								color: "black",
								whiteSpace: "pre-wrap",
								background: "white",
								display: "flex",
								flexDirection: "column",
								alignItems: "start",
								gap: "20px",
								paddingBottom: "20px",
								border: "none",
							}}
						>
							<FAQAnswerDiv>{faq.answer}</FAQAnswerDiv>
						</AccordionDetails>
					</CustomAccordion>
				))}
			</FAQContainer>
			<EmptySpace space={120} />
		</ContentsContainer>
	);
};

